import {defaultStockData, StockDto} from "src/dtos/stock/stockDto";

// 소계 관련 상수 정의
export const SUBTOTAL_TYPES = {
    ITEM: 'item',
    WAREHOUSE: 'warehouse',
    LOGICCENTER: 'logiccenter',
} as const;

export const SUBTOTAL_LEVELS = {
    ITEM: 1,
    WAREHOUSE: 2,
    LOGICCENTER: 3,
    DETAIL: 4,
} as const;

// 전체 재고 DTO (ALL view) - 모든 상세 정보 포함
export interface KSK1080_R01TotalDto extends StockDto {
    brandCd: string;            // 브랜드코드
    brandNm: string;            // 브랜드명
    itemGroup: string;          // 품목그룹    
}

// 품목별 재고 DTO (ITEM view) - 품목 중심, 물류센터/창고 정보 없음
export interface KSK1080_R01ItemDto extends StockDto {
    brandCd: string;            // 브랜드코드
    brandNm: string;            // 브랜드명
    itemGroup: string;          // 품목그룹   
}

// 창고별 재고 DTO (WAREHOUSE view) - 창고 중심, 품목 정보 포함
export interface KSK1080_R01WarehouseDto extends StockDto {
    brandCd: string;            // 브랜드코드
    brandNm: string;            // 브랜드명
    itemGroup: string;          // 품목그룹   
}

// 물류센터별 재고 DTO (CENTER view) - 센터 중심, 품목 정보 포함
export interface KSK1080_R01LogicCenterDto extends StockDto {
    brandCd: string;            // 브랜드코드
    brandNm: string;            // 브랜드명
    itemGroup: string;          // 품목그룹   
}

// LOT별 재고 DTO (LOT view) - LOT 번호별 상세 조회
export interface KSK1080_R01LotDto extends StockDto {

	brandCd: string;            // 브랜드코드
	brandNm: string;            // 브랜드명
	itemGroup: string;          // 품목그룹   
	
    /** 품목 보관위치(로케이션) - 라벨 storageLocation용 */
    locationCd?: string;
    locationNm?: string;
    /** 품목계정 코드명 - 라벨 itemAccountNm용 */
    itemAccountNm?: string;
    lotNo: string;              // LOT 번호
    /** LOT 입고일(라벨 일자용) - yyyy-MM-dd */
    transportDate?: string;
    /** 품목(mst_item).custom_cd → 거래처명(mst_custom.custom_nm) — LOT 뷰·라벨 customer */
    customerNm?: string;
	
}

// 통합 DTO (서버 응답 제네릭을 위한 공통 타입)
export type KSK1080_R01Dto = KSK1080_R01TotalDto | KSK1080_R01ItemDto | KSK1080_R01WarehouseDto | KSK1080_R01LogicCenterDto | KSK1080_R01LotDto;

// 기본값들
export const defaultKSK1080_R01TotalDto: KSK1080_R01TotalDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	
	logicCenter: '',
	logicCenterNm: '',
	warehouseCd: '',
	warehouseNm: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	itemUnit: '',

	stockQty: 0,
	reservQty: 0,
	availableQty: 0,
	
    brandCd: '',
    brandNm: '',
    itemGroup: '',

	inserted: false,
	isModified: false
};

export const defaultKSK1080_R01ItemDto: KSK1080_R01ItemDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	
	logicCenter: '',
	logicCenterNm: '',
	warehouseCd: '',
	warehouseNm: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	itemUnit: '',

	stockQty: 0,
	reservQty: 0,
	availableQty: 0,
	
    brandCd: '',
    brandNm: '',
    itemGroup: '',

	inserted: false,
	isModified: false
};

export const defaultKSK1080_R01WarehouseDto: KSK1080_R01WarehouseDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	
	logicCenter: '',
	logicCenterNm: '',
	warehouseCd: '',
	warehouseNm: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	itemUnit: '',

	stockQty: 0,
	reservQty: 0,
	availableQty: 0,
	
    brandCd: '',
    brandNm: '',
    itemGroup: '',

	inserted: false,
	isModified: false
};

export const defaultKSK1080_R01LogicCenterDto: KSK1080_R01LogicCenterDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	
	logicCenter: '',
	logicCenterNm: '',
	warehouseCd: '',
	warehouseNm: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	itemUnit: '',

	stockQty: 0,
	reservQty: 0,
	availableQty: 0,
	
    brandCd: '',
    brandNm: '',
    itemGroup: '',

	inserted: false,
	isModified: false
};

export const defaultKSK1080_R01LotDto: KSK1080_R01LotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	
	logicCenter: '',
	logicCenterNm: '',
	warehouseCd: '',
	warehouseNm: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	itemUnit: '',

	stockQty: 0,
	reservQty: 0,
	availableQty: 0,

	brandCd: '',
	brandNm: '',
	itemGroup: '',
	lotNo: '',
	locationCd: '',
	locationNm: '',
	itemAccountNm: '',
	transportDate: '',
	customerNm: '',

	inserted: false,
	isModified: false
};

export const defaultKSK1080_R01Dto: KSK1080_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	
	logicCenter: '',
	logicCenterNm: '',
	warehouseCd: '',
	warehouseNm: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	itemUnit: '',

	stockQty: 0,
	reservQty: 0,
	availableQty: 0,

	brandCd: '',
	brandNm: '',
	itemGroup: '',
	lotNo: '',
	locationCd: '',
	locationNm: '',
	itemAccountNm: '',
	transportDate: '',
	customerNm: '',

	inserted: false,
	isModified: false
};

// ===============================
// 소계 관련 인터페이스들
// ===============================

// 품목별 소계 데이터 인터페이스
export interface ItemSubtotalData {
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    brandCd: string;
    brandNm: string;
    itemGroup: string;
    itemStatus: string;
    count: number;
    stockQty: number;
    reservQty: number;
    availableQty: number;
}

// 창고별 소계 데이터 인터페이스
export interface WarehouseSubtotalData extends ItemSubtotalData {
    logicCenter: string;
    logicCenterNm: string;
    warehouseCd: string;
    warehouseNm: string;
    groupKey?: string;
    availableQty: number;
}

// 물류센터별 소계 데이터 인터페이스
export interface LogicCenterSubtotalData extends ItemSubtotalData {
    logicCenter: string;
    logicCenterNm: string;
    groupKey?: string;
    availableQty: number;
}

// 소계 행 인터페이스들
export interface ItemSubtotalRow {
    isSubtotal: true;
    subtotalType: typeof SUBTOTAL_TYPES.ITEM;
    level: typeof SUBTOTAL_LEVELS.ITEM;
    groupKey: string;
    groupLabel: string;
    count: number;
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    brandCd: string;
    brandNm: string;
    itemGroup: string;
    itemStatus: string;
    stockQty: number;
    reservQty: number;
    availableQty: number;
}

export interface WarehouseSubtotalRow {
    isSubtotal: true;
    subtotalType: typeof SUBTOTAL_TYPES.WAREHOUSE;
    level: typeof SUBTOTAL_LEVELS.WAREHOUSE;
    groupKey: string;
    groupLabel: string;
    count: number;
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    itemGroup: string;
    itemStatus: string;
    logicCenter: string;
    logicCenterNm: string;
    warehouseCd: string;
    warehouseNm: string;
    stockQty: number;
    reservQty: number;
    availableQty: number;
}

export interface LogicCenterSubtotalRow {
    isSubtotal: true;
    subtotalType: typeof SUBTOTAL_TYPES.LOGICCENTER;
    level: typeof SUBTOTAL_LEVELS.LOGICCENTER;
    groupKey: string;
    groupLabel: string;
    count: number;
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    itemGroup: string;
    itemStatus: string;
    logicCenter: string;
    logicCenterNm: string;
    warehouseCd: string;
    warehouseNm: string;
    stockQty: number;
    reservQty: number;
    availableQty: number;
}

// 통합 그리드 데이터 타입
export type GridRowData = 
    | ItemSubtotalRow 
    | WarehouseSubtotalRow
    | LogicCenterSubtotalRow
    | (any & { isSubtotal: false; level: typeof SUBTOTAL_LEVELS.DETAIL });